import { Component, OnInit, ViewChild } from '@angular/core';
import { GTopicService } from './g-topic.service'
import { Location } from '@angular/common';
import { GeneralComponent } from './g.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../shared/message.service';

export abstract class GeneralExerciseComponent extends GeneralComponent implements OnInit {


  //all exercises
  id: number;
  protected key: string;
  public solved = false;
  protected examId: number;

  public type: string;

  showTip = true;
  showVideo: boolean = false;
  printable: boolean = false;


  constructor(protected activatedRoute: ActivatedRoute, protected topicService: GTopicService, protected messageService: MessageService) {
    super(topicService);
  }

  /** called after the constructor */
  ngOnInit() {
    //register this exercise as current exercise
    this.topicService.registerExerise(this);

    //load the examID
    this.id = +this.activatedRoute.snapshot.paramMap.get('id');
    if (this.activatedRoute.snapshot.paramMap.has('examid')) {
      this.examId = +this.activatedRoute.snapshot.paramMap.get('examid');
    } else {
      this.examId = -1;
    }

    //initiate the standard activities
    this.getConfiguration();
    this.setTypeSpecificsFromConfiguration();
    this.key = this.configuration.key;
    this.type = this.configuration.type;
    this.getState();
    this.setInfoFromState();
    this.setTypeSpecificsFromState();
  }

  //set solved
  setInfoFromState() {
    if (this.state["solved"] != undefined) {
      this.solved = this.state.solved;
    }
  }

  abstract setTypeSpecificsFromConfiguration();

  abstract setTypeSpecificsFromState();

  get_title(): string {
    return this.configuration["title"];
  }

  get_description(): string {
    return this.configuration["description"];
  }

  getID(): number {
    return this.id;
  }

  /** receives the configruation from the topicService */
  getConfiguration() {
    this.configuration = this.topicService.getExerciseById(this.examId, this.id);
  }
  /** receives the state from the topicService */
  getState() {
    this.state = this.topicService.getStateByKey(this.key);
  }

  /** computes the actual state and adds it to the state */
  saveState() {
    this.computeState();
    let evaluation = this.evaluate();
    this.state.evaluate = Math.round(evaluation[0] * 10) / 10;
    this.state.maxPoints = Math.round(evaluation[1] * 10) / 10;
    this.topicService.setStateByKey(this.key, this.state);
    this.messageService.addAlertWithTimeout(this.get("saveDone"), "success", 2000);
  }

  /** calls the current Exercise to reset the state */
  resetState() {
    this.topicService.resetStateByKey(this.key);
    this.solved = false;
    this.ngOnInit();
  }

  /** redirect to next exercise */
  nextClicked(): string {
    return this.topicService.nextClicked();
  }

  abstract computeState();

  abstract checkSolution();

  abstract evaluate(): number[];


  /** checks if the exercise is part of a self-check exercise set */
  public isExamQuestion(): boolean {
    return this.topicService.isExam(this.examId);
  }

  /** checks if the exericse is part of an exerciseSet */
  public inExerciseSet() {
    return this.examId > -1;
  }

  /** returns the key of the chapter */
  chapterType(): string {
    return this.topicService.type;
  }

  //called before printing
  preprint() { }

  //called after printing
  postprint() { }



}